import { Pipe, PipeTransform } from "@angular/core";
import { TableGroup } from "src/app/components/default/table/table-group";
import { getTableGroupAmount } from "src/helpers/getTableGroupAmount";

@Pipe({
  name: "tableGroupAmount",
  pure: false,
})
export class TableGroupAmountPipe implements PipeTransform {
  public transform(root: TableGroup, variant: "all" | "loaded" = "all"): { visible: number; total: number } {
    return getTableGroupAmount(root, variant);
  }
}
